import React, { useEffect, useState } from 'react';
import { 
    checkActionCode, 
    applyActionCode, 
} from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions"
import Alert from 'react-bootstrap/Alert';

type UpdateEmailTypesenseParams = {
    email : string
}

type ChangePermissionsResult = {
    success: boolean
    reason?: string
}

export const VerifyEmailHandler = ({ auth, actionCode }) => {

    const [isLoading, setIsLoading] = useState(true);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const customVerifyEmail = async () => {
        const info = await checkActionCode(auth, actionCode)
        const newEmail = info['data']['email']
        const functions = getFunctions();
        const updateEmailTypesense = httpsCallable<UpdateEmailTypesenseParams,ChangePermissionsResult>(functions, "updateEmailTypesense");

        try {
            // Apply the change first so Firebase Auth reflects the new email, then
            // sync the roster. The callable reads the authoritative email from Auth
            // rather than trusting a client-supplied value.
            await applyActionCode(auth, actionCode)
            // The change has already applied, so a failed roster sync is not
            // an error for the user.
            try {
                const res = await updateEmailTypesense({email: newEmail})
                if (!res.data.success){
                    console.warn('[VerifyEmailHandler] roster sync failed', res.data.reason)
                }
            } catch (syncError) {
                console.warn('[VerifyEmailHandler] roster sync failed', syncError)
            }
            setSuccessMessage(`Your email ${newEmail} has been verified and will now be the primary email for your account.`)
        } catch (error) {
            setErrorMessage(error.message)
        } finally {
            setIsLoading(false)
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
    useEffect( () => { customVerifyEmail() }, [])

    if (isLoading) {
        return <Alert variant={'primary'}>Loading...</Alert>;
    }

   if (errorMessage) {
       return <Alert variant={'danger'}>Error: {errorMessage}</Alert>
    } 

    return <Alert variant={'success'}>Success! {successMessage}</Alert>;
}